import { Box, styled } from '@mui/material';

export const SearchBarContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  gap: '20px',
  padding: '21px',
});
